import { render, staticRenderFns } from "./DropAreaMulti.vue?vue&type=template&id=0a46ad48&scoped=true"
import script from "./DropAreaMulti.vue?vue&type=script&lang=ts"
export * from "./DropAreaMulti.vue?vue&type=script&lang=ts"
import style0 from "./DropAreaMulti.vue?vue&type=style&index=0&id=0a46ad48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a46ad48",
  null
  
)

export default component.exports